import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { UserSummary } from "../../shared/types";

export function SearchPage() {
  const [q, setQ] = useState("");
  const [users, setUsers] = useState<UserSummary[]>([]);
  const [hashtags, setHashtags] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(async () => {
      if (!q.trim()) { setUsers([]); setHashtags([]); return; }
      setLoading(true);
      const result = await api.search(q);
      setUsers(result.users);
      setHashtags(result.hashtags);
      setLoading(false);
    }, 280);
    return () => window.clearTimeout(timer);
  }, [q]);
  return (
    <section className="page-slab narrow">
      <header className="page-head"><h1>Search</h1><input autoFocus value={q} onChange={(event) => setQ(event.target.value)} placeholder="Search users and hashtags" /></header>
      {loading && <div className="state">Searching...</div>}
      {!q && <div className="state">Recent searches will appear here.</div>}
      {q && !loading && !users.length && !hashtags.length && <div className="state">No results.</div>}
      {users.map((user) => <a className="suggestion large" href={`/@${user.username}`} key={user.id}><img src={user.avatarUrl} alt="" /><span><strong>{user.displayName}</strong><em>@{user.username}</em></span></a>)}
      <div className="topic-row">{hashtags.map((tag) => <a href={`/explore?tag=${tag}`} key={tag}>#{tag}</a>)}</div>
    </section>
  );
}
